import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useDeleteDepartmentOverride } from "@/hooks/useSupportDepartments";
import type { Department, DepartmentOverride } from "@/services/supportDepartmentsService";

import { apiErrorMessage } from "./slackId";

/** A Core "lead" override for someone no longer in this Teamwork department.
 *  It does nothing until they return; Remove deletes it. */
export function DormantLeadRow({
  override,
  department,
}: {
  override: DepartmentOverride;
  department: Department;
}) {
  const remove = useDeleteDepartmentOverride();
  const name = override.display_name || override.email;

  return (
    <li className="flex flex-wrap items-center gap-x-3 gap-y-2 py-2">
      <div className="min-w-[10rem] flex-1 opacity-60">
        <p className="text-sm font-medium text-muted-foreground">{name}</p>
        <p className="text-xs text-muted-foreground">{override.email}</p>
      </div>
      <Badge variant="outline" className="text-muted-foreground">
        Lead override (not in Teamwork now)
      </Badge>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        disabled={remove.isPending}
        aria-label={`Remove lead override for ${name}`}
        onClick={() => remove.mutate({ department: department.key, email: override.email })}
      >
        Remove
      </Button>
      {remove.error ? (
        <p role="alert" className="w-full text-xs text-destructive">
          {apiErrorMessage(remove.error, "the change was not saved.")}
        </p>
      ) : null}
    </li>
  );
}
